import { render, staticRenderFns } from "./AlertStoreDiscount.vue?vue&type=template&id=ec0bcede&"
import script from "./AlertStoreDiscount.vue?vue&type=script&lang=js&"
export * from "./AlertStoreDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports